<template>
  <div class="signatureBox">
    <div class="signatureMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>签章管理</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="signatureCon">
        <div class="signatureItem">
          <div class="signItemHead">
            <ul class="fl">
              <li></li>
              <li>我的签章</li>
            </ul>
            <p class="fr ft12">
              <span>*</span>温馨提示：图片PNG格式，宽度：300像素，高度：300像素；
            </p>
          </div>
          <div class="signItemCon">
            <ul class="signItemList myList">
              <li class="uploadDiv">
                <el-upload
                  class="avatar-uploader"
                  :action="doUpload+`&sealType=${newCur.realNameType||''}&currentUserId=${getUserInfo.currentUserId||''}`"
                  :show-file-list="false"
                  :multiple="false"
                  :headers="uploadHeader()"
                  :on-success="handleAvatarSuccess"
                  :data="uploadData"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="ft14">上传签章</p>
                </el-upload>
              </li>
              <li
                v-for="(item,index) in result"
                :key="item.id"
                class="imgList"
                @mouseover="setMoveFn(index,item.checkStatus)"
                @mouseleave="setleaveFn(index,item.checkStatus)"
              >
                <img :src="item.fullFilePath">
                <div class="mask">
                  <p v-if="item.defaulted=='0'">
                    <span @click="defaultFn(index,item.defaulted,item.id)">设为默认</span>
                    <img
                      src="../../../assets/images/signature/system-delete1.png"
                      @click="delFn(item.id)"
                    >
                  </p>
                </div>
                <span v-show="item.defaulted=='1'" class="defaultBox"></span>
                <div class="statusNum" v-show="item.checkStatus!='2'">
                  <div class="statusNumBox">
                    <span v-if="item.checkStatus==1">审批中...</span>
                    <span v-if="item.checkStatus==3">审批失败...</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="signatureItem">
          <div class="signItemHead">
            <ul class="fl">
              <li></li>
              <li>手写签章</li>
            </ul>
            <p class="fr ft12">
              <span>*</span>温馨提示：图片PNG格式，宽度：119像素，高度：119像素；
            </p>
          </div>
          <div class="signItemCon">
            <ul class="writeList">
              <li class="uploadDiv" @click="writeFn">
                <img src="../../../assets/images/signature/daitaren.png">
                <p class="ft14">手写签名</p>
              </li>
              <li
                v-for="(item,index) in results"
                :key="item.id"
                class="imgList"
                @mouseover="setMoveFns(index,item.checkStatus)"
                @mouseleave="setleaveFns(index,item.checkStatus)"
              >
                <img :src="item.fullFilePath">
                <div class="mask">
                  <p v-if="item.defaulted=='0'">
                    <span @click="defaultFn(index,item.defaulted,item.id)">设为默认</span>
                    <img
                      src="../../../assets/images/signature/system-delete1.png"
                      @click="delFn(item.id)"
                    >
                  </p>
                </div>
                <span v-show="item.defaulted=='1'" class="defaultBox"></span>
                <div class="statusNum" v-show="item.checkStatus!='2'">
                  <div class="statusNumBox">
                    <span v-if="item.checkStatus==1">审批中...</span>
                    <span v-if="item.checkStatus==3">审批失败...</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :visible="dialogTrue"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog" class="hintBox">
        <div class="hintCon">
          <p>该签章确定设置为默认签章？</p>
        </div>
        <div class="hintFoot">
          <span @click="cancelFn">取消</span>
          <span style="margin-left:40px;" @click="trueDefaultFn">确定</span>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="dialogDel"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog" class="hintBox">
        <div class="hintCon">
          <p>确定要删除这个签章？</p>
        </div>
        <div class="hintFoot">
          <span @click="cancelFn">取消</span>
          <span style="margin-left:40px;" @click="trueDelFn">确定</span>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="dialogWrite"
      :dialogTitle="'手写签章'"
      v-on:closeDialog="closeDialog"
      :width="'500px'"
      class="dialogWrite"
    >
      <div slot="dialog" class="hintBox hintBoxs">
        <h3>请打开手机上的扫一扫功能，扫描以下二维码</h3>
        <div class="writeBox">
          <p>－&nbsp;二维码5分钟内有效&nbsp;－</p>
          <vue-qr id="canvas" :logoSrc="imageUrls" :text="codeValue" :size="200"></vue-qr>
        </div>
        <p class="remind">
          <span>提醒：</span>通过扫描二维码功能签署的签名，即表示我同意将该签名作为我的正式签名用于我（或我的代理）的各种文档处理用途，包括具有法律约束力的合约，与用笔在纸上签名具有相同效力。
        </p>
      </div>
    </Dialog>
    <Dialog
      :visible="dialogDio"
      :dialogTitle="'手写签章'"
      v-on:closeDialog="closeDialog"
      :width="'500px'"
      class="dialogWrite"
    >
      <div slot="dialog" class="hintBox hintBoxs">
        <h3>请打开手机上的扫一扫功能，扫描以下二维码</h3>
        <div class="writeBox">
          <p>－&nbsp;二维码5分钟内有效&nbsp;－</p>
          <vue-qr id="canvas" :logoSrc="imageUrls" :text="codeValue" :size="200"></vue-qr>
        </div>
        <p class="remind">
          <span>提醒：</span>通过扫描二维码功能签署的签名，即表示我同意将该签名作为我的正式签名用于我（或我的代理）的各种文档处理用途，包括具有法律约束力的合约，与用笔在纸上签名具有相同效力。
        </p>
      </div>
    </Dialog>
    <Dialog
      :visible="againBox"
      :dialogTitle="'手写签章'"
      v-on:closeDialog="closeDialog"
      :width="'500px'"
      class="dialogWrite"
    >
      <div slot="dialog" class="hintBox hintBoxs">
        <h3>觉得不满意，可以返回重新签哦！</h3>
        <div class="againWriteBox">
          <img :src="returnURL">
        </div>
        <p class="operation">
          <span @click="trueWriteFn">确定</span>
          <span @click="backSign">重新签</span>
        </p>
        <p class="remind">
          <span>提醒：</span>通过扫描二维码功能签署的签名，即表示我同意将该签名作为我的正式签名用于我（或我的代理）的各种文档处理用途，包括具有法律约束力的合约，与用笔在纸上签名具有相同效力。
        </p>
      </div>
    </Dialog>
    <Dialog
      :visible="hintMessage"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
      class="hintMessage"
    >
      <div slot="dialog" class="hintMessConBox">
        <div class="hintMessCon">
          <h2>印章已提交审核</h2>
          <p>印章将在1-3工作日内审核完毕。</p>
        </div>
        <p>
          <span @click="auditTrue">确定</span>
        </p>
      </div>
    </Dialog>
    <Dialog :visible="authDialogShow" :dialogTitle="'消息提示'" :width="'400px'" :showClose="false">
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <!-- <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div> -->
          <div class="button buttonActive cursorPointer" @click="goAuth">去认证</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="hintMessage"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
      class="hintMessage"
    >
      <div slot="dialog" class="hintMessConBox">
        <div class="hintMessCon">
          <h2>印章已提交审核</h2>
          <p>印章将在1-3工作日内审核完毕。</p>
        </div>
        <p>
          <span @click="auditTrue">确定</span>
        </p>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import VueQr from "vue-qr";
import config from "@lib/config.js";
import WebSockt from "@lib/webSocket.js";
import breadcrumb from "@common/Breadcrumb.vue";
import {mapGetters,mapState} from "vuex";
export default {
  data() {
    let _this = this
    return {
      userInfoResult:{},
      hintMessage: false,
      againBox: false,
      file: "",
      uploadList: [],
      imageUrl: "",
      aligin: false,
      result: [],
      results: [],
      doUpload: "/seal/v2/uploadSeal?sourceType=1",
      uploadData: {},
      dialogTrue: false,
      idx: "",
      id: "",
      notTrue: false,
      status: "",
      dialogDel: false,
      dialogDio: false,
      dialogWrite: false,
      authDialogShow: false,
      codeValue: '',
      imageUrls: require("@image/sign/qrcode.png"),
      returnURL: "",
      firstId: "",
      newCur:{}
    };
  },
  mounted() {
    this.init();
  },
  created() {
    this.getUserInfos();
  },
  computed:{
    ...mapState(['currentInfo']),
    ...mapGetters(['getUserInfo','getCurInfo'])
  },
  methods: {
    init() {
      var queryStrs = {
        checkStatus: ""
      };
      this.result = [];
      this.results = [];
      BaseApi.createRpcToken("/seal/v2/sealList", queryStrs).then(
        data => {
          if (data.datas != null) {
            for (var i = 0; i < data.datas.resultList.length; i++) {
              if (data.datas.resultList[i].sourceType == "1" ||data.datas.resultList[i].defaulted==1 ) {
                this.result.push(data.datas.resultList[i]);
              } else {
                this.results.push(data.datas.resultList[i]);
              }
            }
            //根据企业和个人展示签章
            var newCurrent=this.getCurInfo?this.getCurInfo:this.currentInfo;
            this.newCur=newCurrent
            this.result=this.result.filter(item=>item.sealType==newCurrent.realNameType)
            this.results=this.results.filter(item=>item.sealType==newCurrent.realNameType)
            this.firstId = data.datas.resultList[0].id;
            if (this.aligin == true) {
              var queryStrs = {
                ids: this.firstId
              };
              BaseApi.createRpcToken("/seal/deleteById", queryStrs, "post")
                .then(
                  data => {
                    this.aligin = false;
                    this.init();
                    this.dialogDio = true;
                    // if(this.notTrue==false){
                    //   this.dialogDio=false;
                    // }
                  },
                  data => {
                  }
                )
                .catch(function(e) {
                  errorLog(e);
                });
            } else {
              this.aligin = false;
            }
          }
        },
        data => {
        }
      );
    },
    goAuth(){
      let exuserid=sessionStorage.getItem("userInfo")?JSON.parse(sessionStorage.getItem("userInfo")):''
      if(exuserid.person.authenticationStatus!=2 && localStorage.getItem("curID")==exuserid.person.userId){
          this.$router.push({
            path:'/personal/users/home',
            query:{
              userId:exuserid.person.userId
            },
          })
      }else{
         this.$router.push({
            path:'/personal/users/home',
            query:{
              step:this.step,
              exId:exuserid.enterpriseList.length?exuserid.enterpriseList[0].userId:''
            },
          })
      } 
      this.authDialogShow=false;
    },
    getUserInfos() {
      //个人信息需要实时请求 不能缓存
       if(this.getUserInfo.hasOwnProperty('currentUserId')){
        if (!this.getUserInfo.person || this.getUserInfo.person.authenticationStatus != 2) {
          // 未实名显示弹窗禁止操作
          this.authDialogShow = true;
        }
       }
         BaseApi.createRpcToken("/user/v2/getUserInfo")
          .then(data => {
            if(this.getUserInfo.currentUserId==data.datas.person.userId){
              this.userInfoResult=data.datas.person;
            }else{
              this.userInfoResult=data.datas.enterpriseList[0];
            }
            if ( this.userInfoResult.authenticationStatus != 2) {
              // 未实名显示弹窗禁止操作
              this.authDialogShow = true;
            }
          })
          .catch(function(e) {
            errorLog(e);
          });
      
    },
    trueWriteFn() {
      this.init();
      this.againBox = false;
      this.dialogWrite = false;
      this.dialogDio = false;
    },
    auditTrue() {
      this.hintMessage = false;
    },
    backSign() {
      this.againBox = false;
      this.aligin = true;
      this.initWebsocket();
      this.notTrue = false;
      this.init();
      this.dialogDel = false;
    },
    handleAvatarSuccess(res, file) {
      this.$emit("uploadSuccess", res);
      var this_1 = this;
      this.hintMessage = true;
      this_1.init();
    },
    uploadHeader() {
      return {
        token: localStorage.getItem("token"),
        "X-CSRF-Token": sessionStorage.token
      };
    },
    beforeAvatarUpload(file) {
      this.uploadData.sourceType = 1;
      const isPNG = file.type === "image/png";
      if (!isPNG) {
        this.$message.error("上传头像图片只能是PNG格式!");
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 300;
        let height = 300;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;

          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message.error("上传图片大小应为300*300像素");
          return Promise.reject();
        }
      );
      return isPNG && isSize;
    },
    closeDialog(data) {
      this.dialogTrue = data;
      this.dialogDel = data;
      this.dialogWrite = data;
      this.dialogDio = false;
      this.againBox = data;
      this.hintMessage = data;
    },
    initWebsocket() {
      let webSocket = new WebSockt(
        this.$sotre,
        `${config.webSocketUrl}/ws/seal/${localStorage.token ||
          "Tnur5Z01dIINOpTFyv00y8vylkQepF"}`,
        (data, ws) => {
          data = JSON.parse(data).datas;
          this.returnURL = data.fileUrl;
          this.dialogWrite = false;
          this.againBox = true;
        }
      );
      webSocket.wsAddEvent();
    },
    writeFn() {
      this.initWebsocket();
      this.codeValue = `${
        config.mobileSignUrl
      }/m/canvasSign?token=${localStorage.token ||
        "Tnur5Z01dIINOpTFyv00y8vylkQepF"}&username=${encodeURI(
        this.$store?.state?.userInfo?.person?.realName
      )}`
      this.dialogWrite = true;
    },
    setMoveFn(index, status) {
      if (status == "2") {
        $(".myList")
          .find(".imgList")
          .eq(index)
          .find(".mask")
          .css("opacity", "1");
      } else {
        $(".myList")
          .find(".imgList")
          .eq(index)
          .find(".mask")
          .css("opacity", "0");
      }
    },
    setleaveFn(index) {
      $(".myList")
        .find(".imgList")
        .eq(index)
        .find(".mask")
        .css("opacity", "0");
    },
    setMoveFns(index, status) {
      if (status == "2") {
        $(".writeList")
          .find(".imgList")
          .eq(index)
          .find(".mask")
          .css("opacity", "1");
      } else {
        $(".writeList")
          .find(".imgList")
          .eq(index)
          .find(".mask")
          .css("opacity", "0");
      }
    },
    setleaveFns(index) {
      $(".writeList")
        .find(".imgList")
        .eq(index)
        .find(".mask")
        .css("opacity", "0");
    },
    defaultFn(idx, status, id) {
      this.idx = idx;
      this.dialogTrue = true;
      this.id = id;
      this.status = status;
    },
    trueDefaultFn() {
      this.dialogTrue = false;
      var this_1 = this;
      if (this.status == 1) {
        this.status = 0;
      } else {
        this.status = 1;
      }
      var queryStrs = {
        status: this.status,
        id: this.id
      };
      BaseApi.createRpcToken(" /seal/setDefaulted", queryStrs, "post")
        .then(
          data => {
            if (data != undefined) {
              if (data.datas != null) {
                this_1.init();
              }
            }
          },
          data => {
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    trueDelFn() {
      var queryStrs = {
        ids: this.id
      };
      BaseApi.createRpcToken("/seal/deleteById", queryStrs, "post")
        .then(
          data => {
            this.init();
          },
          data => {
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
      this.dialogDel = false;
    },
    cancelFn() {
      this.dialogTrue = false;
      this.dialogDel = false;
    },
    delFn(id) {
      this.id = id;
      this.dialogDel = true;
    }
  },
  components: {
    Dialog,
    VueQr,
    breadcrumb
  },
  watch:{
    "getUserInfo.currentUserId"(data){
      this.getUserInfos();
      this.init();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signatureBox {
  width: 100%;
  height: 100%;
  .signatureMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .signatureHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        color: #787878;
        cursor: pointer;
        font-family: "PingFangSC-Medium";
        cursor: pointer;
      }
      li:last-child {
        color: #e88078;
      }
    }
    .signatureCon {
      width: 100%;
      height: calc(100% - 157px);
      display: table;
      border: 8px solid #f5f5f5;
      box-sizing: border-box;
      margin-top: 30px;
      .signatureItem {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: hidden;
        .signItemHead {
          height: 23px;
          width: 100%;
          overflow: hidden;
          padding: 18px 0;
          line-height: 23px;
          border-bottom: 1px dashed #eb918a;
          li {
            float: left;
          }
          li:nth-child(1) {
            display: block;
            width: 4px;
            height: 20px;
            background: #e88078;
            border-radius: 4px;
            margin-right: 10px;
          }
          li:nth-child(2) {
            color: #e88078;
            font-family: "PingFangSC-Medium";
            font-size: 18px;
          }
          p {
            color: #3c3c3c;
            span {
              vertical-align: middle;
              margin-right: 10px;
              color: #e88078;
            }
          }
        }
        .signItemCon {
          width: 100%;
          overflow: hidden;
          padding-bottom: 15px;
          ul {
            li {
              float: left;
              width: 119px;
              height: 119px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #c8c8c8;
              flex-direction: column;
              margin-right: 20px;
              margin-top: 20px;
              box-sizing: border-box;
            }
            .imgList {
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .mask {
                position: absolute;
                background: rgba(0, 0, 0, 0.1);
                width: 119px;
                height: 119px;
                line-height: 24px;
                top: 0;
                left: 0;
                color: #505050;
                font-size: 12px;
                opacity: 0;
                p {
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  height: 24px;
                  background: rgba(0, 0, 0, 0.15);
                  padding: 0 10px;
                  box-sizing: border-box;
                  img {
                    float: right;
                    width: 14px;
                    height: 14px;
                    vertical-align: middle;
                    margin-top: 4px;
                  }
                }
              }
              .defaultBox {
                position: absolute;
                left: 0;
                top: 0;
                width: 48px;
                height: 48px;
                background: url("../../../assets/images/signature/Group17.png");
              }
              .statusNum {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                line-height: 119px;
                color: #fff;
                font-size: 14px;
                text-align: center;
                .statusNumBox {
                  // z-index: 555 ;
                  background: rgba(0, 0, 0, 0.5);
                  pointer-events: none;
                }
              }
            }
            .uploadDiv {
              border: 2px dashed #c8c8c8;
              position: relative;

              cursor: pointer;
              .el-icon-plus:before {
                position: absolute;
                top: -6%;
                left: 45px;
                color: #e88078;
              }
              img {
                position: absolute;
                top: 30%;
                left: 45px;
              }
              p {
                position: absolute;
                top: 55%;
                width: 100%;
                text-align: center;
                margin-top: 10px;
                color: #969696;
              }
              .aginFile {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: none;
                pointer-events: none;
                z-index: 3;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .avatar-uploader {
                width: 119px;
                height: 119px;
              }
              .avatar-uploader .el-upload {
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width: 119px;
                height: 119px;
              }
              .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100%;
                height: 100%;
                line-height: 119px;
                text-align: center;
              }
              .avatar {
                width: 119px;
                height: 119px;
                display: block;
              }
            }
            .uploadDiv:hover {
              p {
                color: #e88078;
              }
            }
            .uploadItem {
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .aginFile {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: none;
                pointer-events: none;
                z-index: 3;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .uploadDiv:hover {
              border-color: #e88078;
            }
            .uploadItem:nth-child(1) {
              background: url("../../../assets/images/signature/Group17.png");
            }
          }
        }
      }
    }
  }
  .hintBox {
    height: 200px;
    text-align: center;
    .hintCon {
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        line-height: 24px;
      }
      p:nth-child(1) {
        color: #646464;
      }
      p:last-child {
        color: #282828;
      }
    }
    .hintFoot {
      margin-bottom: 30px;
      span {
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #D81212;
        color: #D81212;
        font-size: 12px;
      }
      span:hover {
        background: #D81212;
        color: #fff;
      }
    }
  }
  .dialogWrite {
    .header {
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      .el-icon-close {
        top: 23px;
      }
    }
    .hintBoxs {
      height: 425px;
      h3 {
        padding: 18px 0;
        font-size: 16px;
        color: #646464;
        font-weight: normal;
      }
      .writeBox {
        margin: 20px 0 40px 0;
        p {
          color: #4daff7;
          font-size: 12px;
          margin-bottom: 10px;
        }
        img {
          width: 200px;
          height: 200px;
        }
      }
      .againWriteBox {
        margin: 0 auto;
        width: 389px;
        height: 219px;
        border: 1px dashed #e4e8eb;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 170px;
          height: 170px;
        }
      }
      #canvas {
        margin: 0 auto;
        width: 200px !important;
        height: 200px !important;
        display: block;
        padding-left: 46px;
      }
      .remind {
        font-size: 12px;
        color: #000000;
        letter-spacing: 0;
        text-align: justify;
        line-height: 20px;
        padding: 0 20px;
        span {
          color: #e88078;
        }
      }
      .operation {
        width: 100%;
        display: table;
        margin-bottom: 15px;
        margin-top: 20px;
        span {
          display: inline-block;
          width: 120px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #db4437;
          border-radius: 2px;
          font-family: "PingFangSC-Medium";
          font-size: 14px;
          color: #db4437;
          text-align: center;
        }
        span:nth-child(1) {
          margin-right: 69px;
        }
      }
    }
  }
  .hintMessConBox {
    width: 400px;
    height: 200px;
    text-align: align;
    .hintMessCon {
      width: 100%;
      height: 136px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #646464;
      h2 {
        font-size: 18px;
        font-weight: normal;
      }
      p {
        font-size: 16px;
        margin-top: 10px;
      }
    }
    p {
      text-align: center;
      span {
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #D81212;
        font-size: 12px;
        color: #D81212;
        text-align: center;
        cursor: pointer;
      }
      span:hover {
        background-color: #D81212;
        color: #fff;
      }
    }
  }
}
</style>
